import React, { useRef, useState, useEffect } from 'react';
import { Segment, Button, Icon, Message } from 'semantic-ui-react';
import { observer } from 'mobx-react';

import AddEditStore from './Store';
import { toJS } from 'mobx';

const FormDragToDropFile = ({ ...props }) => {
  const fileInputRef = useRef();
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [validFiles, setValidFiles] = useState([]);
  const [unsupportedFiles, setUnsupportedFiles] = useState([]);
  const [errorMessage, setErrorMessage] = useState('');

  useEffect(() => {
    let filteredArr = selectedFiles.reduce((acc, current) => {
      const x = acc.find(item => item.name === current.name);
      if (!x) {
        return acc.concat([current]);
      } else {
        return acc;
      }
    }, []);
    setValidFiles([...filteredArr]);
  }, [selectedFiles]);

  const dragOver = e => {
    e.preventDefault();
  };

  const dragEnter = e => {
    e.preventDefault();
  };

  const dragLeave = e => {
    e.preventDefault();
  };

  const fileDrop = e => {
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files.length) {
      handleFiles(files);
      return { errorMessage, validFiles, unsupportedFiles };
    }
  };

  const filesSelected = () => {
    if (fileInputRef.current.files.length) {
      handleFiles(fileInputRef.current.files);
    }
  };

  const fileInputClicked = () => {
    fileInputRef.current.click();
  };

  const handleFiles = files => {
    for (let i = 0; i < files.length; i++) {
      if (validateFile(files[i])) {
        setSelectedFiles(prevArray => [...prevArray, files[i]]);
      } else {
        files[i]['invalid'] = true;
        setSelectedFiles(prevArray => [...prevArray, files[i]]);
        setErrorMessage('File type not permitted');
        setUnsupportedFiles(prevArray => [...prevArray, files[i]]);
      }
    }
  };

  const validateFile = file => {
    const { uploadRule } = AddEditStore;
    const rules = toJS(uploadRule)
      .map(i => {
        if (i.reportType.indexOf(props.fileType) !== -1) {
          return i.rule;
        }
        return null;
      })
      .filter(i => i);
    if (rules) {
      if (
        rules[0].fileExtension.indexOf(`image/${file.type}`) === -1 &&
        rules[0].fileExtension.indexOf(`audio/file.type`) === -1 &&
        rules[0].fileExtension.indexOf(`audio/file.type`) === -1
      ) {
        return false;
      } else if (
        file.size / 1024 / 1024 >
        parseInt(rules.maxSize[0].replace('mb') / 10)
      ) {
        return false;
      }
    }
    return true;
  };

  return (
    <React.Fragment>
      {props.attachments ? (
        <Segment className="add-file-container">
          {props.attachments.map(i => (
            <Message key={i.Id} className="upload-box">
              <div className="file-info">
                <div className="file-info-inner">
                  <Icon name="file alternate" />
                  <div className="file-name">{i.Title}</div>
                </div>
                <div className="file-actions">
                  <Icon name="download" />
                  <Icon name="delete" color="red" />
                </div>
              </div>
            </Message>
          ))}
        </Segment>
      ) : (
        <Segment className="add-file-container">
          <div
            onDragOver={dragOver}
            onDragEnter={dragEnter}
            onDragLeave={dragLeave}
            onDrop={fileDrop}
            className="add-file-container-text"
          >
            <div
              style={{
                marginTop: '20px',
                fontWeight: 500,
                letterSpacing: '0.2px',
              }}
            >
              <span>Drop {props.fileName} here</span>
            </div>
            <div style={{ marginTop: '20px', color: 'grey', fontWeight: 500 }}>
              <span>or click</span>
            </div>
          </div>
          <div className="add-file-container-btn-area">
            <Button onClick={fileInputClicked} className="blue button-add-file">
              <input
                ref={fileInputRef}
                type="file"
                hidden
                multiple
                onChange={filesSelected}
              />
              <Icon name="plus" /> ADD FILES
            </Button>
          </div>
        </Segment>
      )}
    </React.Fragment>
  );
};

export default observer(FormDragToDropFile);
